<aside
  class="eva-sidebar"
  [class.show]="isMobileMenuToggled && isMobile"
  [class.hide]="!isMobileMenuToggled && isMobile"
  [class.mobile-sidebar]="isMobile"
  [class.desktop-sidebar]="!isMobile"
  [class.minimized]="isMinimized"
  [class.expanded]="!isMenuCollapsed || isMenuHovered"
  [class.collapsed]="isMenuCollapsed"
>
  <!-- ============================================ -->
  <!-- 0. HEADER (Logo)                              -->
  <!-- ============================================ -->
  <div class="eva-sidebar__header" *ngIf="!isMinimized">
    <a class="eva-sidebar__header-brand" routerLink="/home">
      <img src="assets/img/eva-logo-round.svg" alt="EVA" class="eva-sidebar__header-logo" />
    </a>
    <button
      class="eva-sidebar__header-toggle"
      (click)="toggleCollapse()"
      evaTooltip="Replier le menu"
      evaTooltipPosition="right"
    >
      <ng-icon name="heroArrowLeftCircle" size="18px"></ng-icon>
    </button>
  </div>

  <!-- Header minimisé -->
  <div class="eva-sidebar__header eva-sidebar__header--mini" *ngIf="isMinimized">
    <button
      class="eva-sidebar__header-toggle"
      (click)="toggleCollapse()"
      evaTooltip="Déplier le menu"
      evaTooltipPosition="right"
    >
      <ng-icon name="heroArrowRightCircle" size="18px"></ng-icon>
    </button>
  </div>

  <!-- ============================================ -->
  <!-- 2. NAVIGATION (scrollable)                   -->
  <!-- ============================================ -->
  <nav class="eva-sidebar__nav">
    <div class="eva-sidebar__nav-scroll">
      <!-- Search button in navigation -->
      <button
        class="eva-sidebar__nav-search"
        (click)="openCommandPalette(); $event.stopPropagation()"
        [evaTooltip]="isMinimized ? 'Rechercher (⌘K)' : ''"
        evaTooltipPosition="right"
      >
        <ng-icon name="heroMagnifyingGlass" size="18px" class="eva-sidebar__nav-search-icon"></ng-icon>
        <span class="eva-sidebar__nav-search-label" *ngIf="!isMinimized">Rechercher</span>
        <kbd class="eva-sidebar__nav-search-kbd" *ngIf="!isMinimized">⌘K</kbd>
      </button>

      <ul class="eva-sidebar__menu">
        <li *ngFor="let group of menuItems" class="eva-sidebar__group">
          <!-- Group separator -->
          <div class="eva-sidebar__separator" *ngIf="group.topSeparator"></div>

          <!-- Group label -->
          <div class="eva-sidebar__group-label" *ngIf="group.label && !isMinimized">
            {{ group.label }}
          </div>
          <div class="eva-sidebar__group-dot" *ngIf="group.label && isMinimized">
            <span class="eva-sidebar__dot"></span>
          </div>

          <!-- Menu items -->
          <ul class="eva-sidebar__items">
            <li *ngFor="let item of group.items" class="eva-sidebar__item-wrapper">
              <a
                class="eva-sidebar__item"
                [routerLink]="item.path"
                routerLinkActive="eva-sidebar__item--active"
                [routerLinkActiveOptions]="{ exact: false }"
                [evaTooltip]="isMinimized ? item.title : ''"
                evaTooltipPosition="right"
                (click)="closeSidebar()"
              >
                <!-- Active indicator bar -->
                <span class="eva-sidebar__item-indicator"></span>

                <!-- Icon -->
                <ng-icon [name]="item.icon" class="eva-sidebar__item-icon" size="18px"></ng-icon>

                <!-- Label + badge (hidden when minimized) -->
                <span class="eva-sidebar__item-content" *ngIf="!isMinimized">
                  <span class="eva-sidebar__item-label">
                    {{ item.title }}
                  </span>

                  <!-- Accounting sync badge -->
                  <eva-badge
                    *ngIf="item.title === 'Comptabilite' && hasAccountingConnections"
                    [dot]="true"
                    severity="success"
                    evaTooltip="Synchronise a un logiciel comptable"
                    evaTooltipPosition="right"
                    class="eva-sidebar__item-sync-badge"
                  ></eva-badge>

                  <!-- Pro upgrade badge -->
                  <img
                    *ngIf="item.category === 'pro' || group.category === 'pro'"
                    src="assets/img/formulas/upgrade-badge.svg"
                    class="eva-sidebar__item-pro-badge"
                    evaTooltip="Fonctionnalite disponible dans nos formules superieures"
                    evaTooltipPosition="right"
                  />
                </span>
              </a>
            </li>
          </ul>
        </li>
      </ul>

      <!-- Upgrade formula section -->
      <div class="eva-sidebar__upgrade" *ngIf="showCommercialItems && showUpgradeFormula && !isMinimized">
        <div class="eva-sidebar__upgrade-icon">
          <ng-icon name="heroQuestionMarkCircle" size="18px"></ng-icon>
        </div>

        <!-- Trial state -->
        <div class="eva-sidebar__upgrade-content" *ngIf="evaSubscription?.status === 'TRIAL'">
          <span class="eva-sidebar__upgrade-text"> Vous souhaitez essayer une autre formule ? </span>
          <eva-button
            label="Changer de formule"
            variant="text"
            severity="secondary"
            (click)="openFormula(false)"
          ></eva-button>
          <eva-button label="Souscrire" severity="primary" size="small" (click)="openFormula(true)"></eva-button>
        </div>

        <!-- Active state -->
        <div class="eva-sidebar__upgrade-content" *ngIf="evaSubscription?.status === 'ACTIVE'">
          <span class="eva-sidebar__upgrade-text"> Changer de formule pour plus de fonctionnalites ? </span>
          <eva-button
            label="Voir les formules"
            severity="primary"
            size="small"
            (click)="openFormula(true)"
          ></eva-button>
          <eva-button
            label="Masquer"
            size="small"
            variant="text"
            tooltip="Masquer cette section et les menus non disponibles"
            tooltipPosition="right"
            (click)="hideCommercialItems()"
          ></eva-button>
        </div>
      </div>

      <!-- Copyright (hidden, toggled with Ctrl+E) -->
      <div class="eva-sidebar__copyright" *ngIf="showEvaCopyright && !isMinimized" (click)="clickVersion()">
        <span class="eva-sidebar__copyright-text">&copy; EVA</span>
        <eva-button
          *ngIf="newVersionAvailable"
          icon="heroArrowPath"
          label="Mettre a jour"
          size="small"
          (click)="promptUserToUpdate(); $event.stopPropagation()"
          tooltip="Une nouvelle version est disponible"
          tooltipPosition="right"
        ></eva-button>
        <span class="eva-sidebar__copyright-version" *ngIf="showAppVersion"> version : {{ appVersion }} </span>
      </div>
    </div>
  </nav>

  <!-- ============================================ -->
  <!-- 2.5 ASSISTANCE (entrée action — ouvre le drawer)  -->
  <!-- ============================================ -->
  <ul class="eva-sidebar__items eva-sidebar__items--help">
    <li class="eva-sidebar__item-wrapper">
      <a
        class="eva-sidebar__item"
        (click)="openHelp()"
        [evaTooltip]="isMinimized ? 'Assistance' : ''"
        evaTooltipPosition="right"
      >
        <span class="eva-sidebar__item-indicator"></span>
        <ng-icon name="heroQuestionMarkCircle" class="eva-sidebar__item-icon" size="18px"></ng-icon>
        <span class="eva-sidebar__item-content" *ngIf="!isMinimized">
          <span class="eva-sidebar__item-label">Assistance</span>
        </span>
      </a>
    </li>
  </ul>

  <!-- ============================================ -->
  <!-- 3. FOOTER (Workspace)                        -->
  <!-- ============================================ -->
  <div class="eva-sidebar__footer" *ngIf="!isMinimized">
    <!-- Workspace selector -->
    <div class="eva-sidebar__workspace" *ngIf="dataLoaded">
      <div class="eva-sidebar__workspace-trigger" [class.active]="workspaceMenuVisible" (click)="toggleWorkspaceMenu()">
        <!-- Company avatar -->
        <span class="eva-sidebar__workspace-avatar" [style.background-color]="getCurrentCompanyColor()">
          {{ getCompanyInitials() }}
        </span>

        <!-- Company info -->
        <div class="eva-sidebar__workspace-info">
          <span class="eva-sidebar__workspace-name">{{ getCurrentCompanyName() }}</span>
          <span class="eva-sidebar__workspace-user">{{ currentEmployee?.display_name }}</span>
        </div>

        <!-- Chevron -->
        <ng-icon name="heroChevronUpDown" class="eva-sidebar__workspace-chevron" size="16px"></ng-icon>
      </div>

      <!-- Workspace overlay menu -->
      <div
        class="eva-sidebar__workspace-overlay"
        *ngIf="workspaceMenuVisible"
        (click)="$event.stopPropagation()"
        (keydown)="onOverlayKeydown($event)"
      >
        <!-- Company switching (if multiple) -->
        <div *ngIf="hasMultipleCompanies" class="eva-sidebar__overlay-section">
          <div class="eva-sidebar__overlay-section-label">Changer de société</div>

          <!-- Search input (shown when > 3 companies) -->
          <div class="eva-sidebar__company-search" *ngIf="currentEvaCompaniesAvailable.length > 3">
            <ng-icon name="heroMagnifyingGlass" size="14px" class="eva-sidebar__company-search-icon"></ng-icon>
            <input
              #companySearchInput
              type="text"
              class="eva-sidebar__company-search-input"
              placeholder="Rechercher..."
              [(ngModel)]="companySearchQuery"
              autocomplete="off"
            />
            @if (currentEvaCompaniesAvailable.length > 10) {
              <eva-button
                class="eva-sidebar__company-refresh"
                icon="heroArrowPath"
                variant="text"
                severity="secondary"
                size="small"
                label="Actualiser la liste des sociétés"
                tooltip="Actualiser la liste des sociétés"
                [loading]="companiesLoading"
                (onClick)="fetchEvaCompanies(true)"
              ></eva-button>
            }
          </div>

          <div class="eva-sidebar__company-dropdown-list">
            <div
              class="eva-sidebar__company-dropdown-item"
              *ngFor="let company of filteredCompanies; let i = index"
              [class.selected]="company.eva_company_id === currentEvaCompanyId"
              [class.focused]="overlayFocusIndex === i"
              (click)="selectCompany(company.eva_company_id)"
            >
              <span
                class="eva-sidebar__company-dropdown-avatar"
                [style.background-color]="getCompanyColor(company.eva_company_id)"
              >
                {{ getCompanyInitials(company.eva_company_id) }}
              </span>
              <span class="eva-sidebar__company-dropdown-name">{{ company.name }}</span>
              <ng-icon
                *ngIf="company.eva_company_id === currentEvaCompanyId"
                name="heroCheck"
                class="eva-sidebar__company-dropdown-check"
                size="16px"
              ></ng-icon>
            </div>

            <div class="eva-sidebar__company-dropdown-empty" *ngIf="filteredCompanies.length === 0">Aucun résultat</div>
          </div>
        </div>

        <div class="eva-sidebar__overlay-divider" *ngIf="hasMultipleCompanies"></div>

        <!-- Navigation items -->
        <div class="eva-sidebar__overlay-section">
          <a
            *ngIf="!isOfficeEmployee"
            class="eva-sidebar__overlay-item"
            [class.focused]="overlayFocusIndex === getMenuItemBaseIndex('company')"
            href="#/settings?section=company"
            (click)="onOverlayLink($event, 'company')"
            (auxclick)="closeWorkspaceMenu()"
          >
            <ng-icon name="heroCog6Tooth" size="16px"></ng-icon>
            <span>Paramètres entreprise</span>
          </a>
          <a
            class="eva-sidebar__overlay-item"
            [class.focused]="overlayFocusIndex === getMenuItemBaseIndex('profile')"
            href="#/settings?section=profile"
            (click)="onOverlayLink($event, 'profile')"
            (auxclick)="closeWorkspaceMenu()"
          >
            <ng-icon name="heroUser" size="16px"></ng-icon>
            <span>Mon profil</span>
          </a>
          <a
            *ngIf="hasAccessToPlanning"
            class="eva-sidebar__overlay-item"
            [class.focused]="overlayFocusIndex === getMenuItemBaseIndex('working-activity')"
            href="#/employee/working-activity"
            (click)="onOverlayLink($event, 'working-activity')"
            (auxclick)="closeWorkspaceMenu()"
          >
            <ng-icon name="heroClock" size="16px"></ng-icon>
            <span>Mon temps de travail</span>
          </a>
        </div>

        <!-- Superadmin -->
        <ng-container *ngIf="adminMenuItems.length > 0">
          <div class="eva-sidebar__overlay-divider"></div>
          <div class="eva-sidebar__overlay-section">
            <div class="eva-sidebar__overlay-section-label">Administration</div>
            <a
              class="eva-sidebar__overlay-item"
              *ngFor="let item of adminMenuItems"
              href="#{{ item.path }}"
              (click)="navigateToAdmin(item.path)"
            >
              <ng-icon [name]="item.icon" size="16px"></ng-icon>
              <span>{{ item.title }}</span>
            </a>
          </div>
        </ng-container>

        <div class="eva-sidebar__overlay-divider"></div>

        <!-- Logout -->
        <div class="eva-sidebar__overlay-section">
          <a
            class="eva-sidebar__overlay-item eva-sidebar__overlay-item--danger"
            [class.focused]="overlayFocusIndex === getMenuItemBaseIndex('logout')"
            (click)="logout()"
          >
            <ng-icon name="heroArrowRightStartOnRectangle" size="16px"></ng-icon>
            <span>Déconnexion</span>
          </a>
        </div>
      </div>
    </div>
  </div>

  <!-- Minimized footer -->
  <div class="eva-sidebar__footer-mini" *ngIf="isMinimized">
    <div class="eva-sidebar__footer-divider"></div>

    <!-- Workspace avatar minimisé -->
    <div class="eva-sidebar__workspace-mini" *ngIf="dataLoaded" (click)="toggleWorkspaceMenu()">
      <span
        class="eva-sidebar__workspace-avatar eva-sidebar__workspace-avatar--small"
        [style.background-color]="getCurrentCompanyColor()"
      >
        {{ getCompanyInitials() }}
      </span>

      <!-- Workspace overlay menu (minimized) -->
      <div
        class="eva-sidebar__workspace-overlay eva-sidebar__workspace-overlay--mini"
        *ngIf="workspaceMenuVisible"
        (click)="$event.stopPropagation()"
        (keydown)="onOverlayKeydown($event)"
      >
        <!-- Company switching (if multiple) -->
        <div *ngIf="hasMultipleCompanies" class="eva-sidebar__overlay-section">
          <div class="eva-sidebar__overlay-section-label">Changer de société</div>

          <div class="eva-sidebar__company-search" *ngIf="currentEvaCompaniesAvailable.length > 3">
            <ng-icon name="heroMagnifyingGlass" size="14px" class="eva-sidebar__company-search-icon"></ng-icon>
            <input
              #companySearchInput
              type="text"
              class="eva-sidebar__company-search-input"
              placeholder="Rechercher..."
              [(ngModel)]="companySearchQuery"
              autocomplete="off"
            />
            @if (currentEvaCompaniesAvailable.length > 10) {
              <eva-button
                class="eva-sidebar__company-refresh"
                icon="heroArrowPath"
                variant="text"
                severity="secondary"
                size="small"
                label="Actualiser la liste des sociétés"
                tooltip="Actualiser la liste des sociétés"
                [loading]="companiesLoading"
                (onClick)="fetchEvaCompanies(true)"
              ></eva-button>
            }
          </div>

          <div class="eva-sidebar__company-dropdown-list">
            <div
              class="eva-sidebar__company-dropdown-item"
              *ngFor="let company of filteredCompanies; let i = index"
              [class.selected]="company.eva_company_id === currentEvaCompanyId"
              [class.focused]="overlayFocusIndex === i"
              (click)="selectCompany(company.eva_company_id)"
            >
              <span
                class="eva-sidebar__company-dropdown-avatar"
                [style.background-color]="getCompanyColor(company.eva_company_id)"
              >
                {{ getCompanyInitials(company.eva_company_id) }}
              </span>
              <span class="eva-sidebar__company-dropdown-name">{{ company.name }}</span>
              <ng-icon
                *ngIf="company.eva_company_id === currentEvaCompanyId"
                name="heroCheck"
                class="eva-sidebar__company-dropdown-check"
                size="16px"
              ></ng-icon>
            </div>

            <div class="eva-sidebar__company-dropdown-empty" *ngIf="filteredCompanies.length === 0">Aucun résultat</div>
          </div>
        </div>

        <div class="eva-sidebar__overlay-divider" *ngIf="hasMultipleCompanies"></div>

        <!-- Navigation items -->
        <div class="eva-sidebar__overlay-section">
          <a
            *ngIf="!isOfficeEmployee"
            class="eva-sidebar__overlay-item"
            [class.focused]="overlayFocusIndex === getMenuItemBaseIndex('company')"
            href="#/settings?section=company"
            (click)="onOverlayLink($event, 'company')"
            (auxclick)="closeWorkspaceMenu()"
          >
            <ng-icon name="heroCog6Tooth" size="16px"></ng-icon>
            <span>Paramètres entreprise</span>
          </a>
          <a
            class="eva-sidebar__overlay-item"
            [class.focused]="overlayFocusIndex === getMenuItemBaseIndex('profile')"
            href="#/settings?section=profile"
            (click)="onOverlayLink($event, 'profile')"
            (auxclick)="closeWorkspaceMenu()"
          >
            <ng-icon name="heroUser" size="16px"></ng-icon>
            <span>Mon profil</span>
          </a>
          <a
            *ngIf="hasAccessToPlanning"
            class="eva-sidebar__overlay-item"
            [class.focused]="overlayFocusIndex === getMenuItemBaseIndex('working-activity')"
            href="#/employee/working-activity"
            (click)="onOverlayLink($event, 'working-activity')"
            (auxclick)="closeWorkspaceMenu()"
          >
            <ng-icon name="heroClock" size="16px"></ng-icon>
            <span>Mon temps de travail</span>
          </a>
        </div>

        <!-- Superadmin -->
        <ng-container *ngIf="adminMenuItems.length > 0">
          <div class="eva-sidebar__overlay-divider"></div>
          <div class="eva-sidebar__overlay-section">
            <div class="eva-sidebar__overlay-section-label">Administration</div>
            <a
              class="eva-sidebar__overlay-item"
              *ngFor="let item of adminMenuItems"
              href="#{{ item.path }}"
              (click)="navigateToAdmin(item.path)"
            >
              <ng-icon [name]="item.icon" size="16px"></ng-icon>
              <span>{{ item.title }}</span>
            </a>
          </div>
        </ng-container>

        <div class="eva-sidebar__overlay-divider"></div>

        <!-- Logout -->
        <div class="eva-sidebar__overlay-section">
          <a
            class="eva-sidebar__overlay-item eva-sidebar__overlay-item--danger"
            [class.focused]="overlayFocusIndex === getMenuItemBaseIndex('logout')"
            (click)="logout()"
          >
            <ng-icon name="heroArrowRightStartOnRectangle" size="16px"></ng-icon>
            <span>Déconnexion</span>
          </a>
        </div>
      </div>
    </div>
  </div>

  <!-- Toast for update notification -->
  <p-toast position="bottom-center" key="c" (onClose)="onRejectUpdate()" [baseZIndex]="5000">
    <ng-template let-message pTemplate="message">
      <div class="d-flex flex-column" style="flex: 1">
        <div class="text-center">
          <ng-icon name="heroArrowPath" style="font-size: 3rem"></ng-icon>
          <h4>Mise a jour disponible !</h4>
          <p>Souhaitez-vous l'installer immediatement ?</p>
          <p>
            Attention, vous perdrez votre travail non sauvegarde. Si vous souhaitez faire la mise a jour ulterieurement,
            rafraichissez la page ou relancer votre application.
          </p>
        </div>
        <div class="row">
          <div class="col-6">
            <eva-button (click)="onConfirmUpdate()" label="Oui" severity="success" [block]="true"></eva-button>
          </div>
          <div class="col-6">
            <eva-button (click)="onRejectUpdate()" label="Non" severity="secondary" [block]="true"></eva-button>
          </div>
        </div>
      </div>
    </ng-template>
  </p-toast>
</aside>

<!-- Mobile backdrop overlay -->
<div *ngIf="isMobileMenuToggled && isMobile" class="eva-sidebar__backdrop" (click)="closeSidebar()"></div>
